module.exports = __webpack_public_path__ + "images/emoji/bee.5c9d6132112f0110044f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bee.png
// module id = 7iak
// module chunks = 2